import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconApps16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconApps16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.582 2.028H2.5a.5.5 0 0 0-.5.5V5.61a.5.5 0 0 0 .5.5h3.082a.5.5 0 0 0 .5-.5V2.528a.5.5 0 0 0-.5-.5m-3.082-1a1.5 1.5 0 0 0-1.5 1.5V5.61a1.5 1.5 0 0 0 1.5 1.5h3.082a1.5 1.5 0 0 0 1.5-1.5V2.528a1.5 1.5 0 0 0-1.5-1.5zm0 8.82h3.082a.5.5 0 0 1 .5.5v3.082a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-3.082a.5.5 0 0 1 .5-.5m-1.5.5a1.5 1.5 0 0 1 1.5-1.5h3.082a1.5 1.5 0 0 1 1.5 1.5v3.082a1.5 1.5 0 0 1-1.5 1.5H2.5a1.5 1.5 0 0 1-1.5-1.5zm9.32-.5h3.08a.5.5 0 0 1 .5.5v3.082a.5.5 0 0 1-.5.5h-3.08a.5.5 0 0 1-.5-.5v-3.082a.5.5 0 0 1 .5-.5m-1.5.5a1.5 1.5 0 0 1 1.5-1.5h3.08a1.5 1.5 0 0 1 1.5 1.5v3.082a1.5 1.5 0 0 1-1.5 1.5h-3.08a1.5 1.5 0 0 1-1.5-1.5zm3.04-9.168a.5.5 0 0 1 .5.5v1.89h1.89a.5.5 0 1 1 0 1h-1.89v1.889a.5.5 0 0 1-1 0v-1.89H9.472a.5.5 0 0 1 0-1h1.89V1.68a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconApps16);
